export default {
  RETIREMENT_INVESTOR_GOAL_CALCULATOR_REPOSITORY: Symbol.for('RETIREMENT_INVESTOR_GOAL_CALCULATOR_REPOSITORY'),
  GET_RETIREMENT_INVESTOR_GOAL_CALCULATOR_QUERY: Symbol.for('GET_RETIREMENT_INVESTOR_GOAL_CALCULATOR_QUERY'),
  CALCULATE_RETIREMENT_GOAL_MINIMUM_MONTHLY_PENSION_QUERY: Symbol.for('CALCULATE_RETIREMENT_GOAL_MINIMUM_MONTHLY_PENSION_QUERY'),
};
